import { FC } from "react";

// Shown on Change Email / Change Password so members know third-party providers (Archistar, RP Data) are not updated automatically.
const REIAccountUpdateDisclaimer: FC = () => (
  <div className="bg-yellow-50 border border-yellow-300 text-sm text-gray-800 rounded-md p-3 mb-4">
    <p className="font-bold mb-1">Important Disclaimer:</p>
    <p>
      Updating your email address or password will only apply to your Real Estate Investar membership. This includes
      your login credentials for our website, email communications, and billing receipts. It <strong>will not</strong>{" "}
      update your details with any third-party services such as Archistar or RP Data. You will need to update your
      information directly with these providers.
    </p>
  </div>
);

export default REIAccountUpdateDisclaimer;
